import {
  PLAN_IDS,
  normalizeCheckoutPlanId,
} from "@cedrum/shared-web/product/plans";

const DEFAULT_LOCAL_APP_ORIGIN = 'http://localhost:3001';
export const APP_ROUTE = '/';
export const SIGN_IN_ROUTE = '/sign-in';
export const SIGN_UP_ROUTE = '/sign-up';

function normalizeBaseUrl(rawValue) {
  const raw = String(rawValue || '').trim();
  if (!raw) {
    return '';
  }

  try {
    const parsed = new URL(raw);
    parsed.hash = '';
    parsed.search = '';
    return parsed.toString().replace(/\/+$/, '');
  } catch {
    return raw.replace(/\/+$/, '');
  }
}

function resolveConfiguredBaseUrl() {
  const configured = normalizeBaseUrl(import.meta.env.VITE_PUBLIC_APP_URL);
  if (configured) {
    return configured;
  }

  // Use the dedicated app origin when unset so auth routes never fall back to the marketing site.
  return DEFAULT_LOCAL_APP_ORIGIN;
}

function buildUrl(baseUrl, routePath) {
  const base = normalizeBaseUrl(baseUrl);
  const route = String(routePath || '/').startsWith('/')
    ? String(routePath || '/')
    : `/${String(routePath || '/')}`;

  if (!base) {
    return route;
  }

  try {
    return new URL(route, `${base}/`).toString();
  } catch {
    return `${base}${route}`;
  }
}

export const clerkPublishableKey = String(
  import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || '',
).trim();

export const isClerkEnabled = Boolean(clerkPublishableKey);
export const appBaseUrl = resolveConfiguredBaseUrl();
export const appEntryUrl = buildUrl(appBaseUrl, APP_ROUTE);
export const appSignInUrl = buildUrl(appBaseUrl, SIGN_IN_ROUTE);
export const appSignUpUrl = buildUrl(appBaseUrl, SIGN_UP_ROUTE);
export const appBillingUrl = buildUrl(appBaseUrl, '/app/billing');

export function buildAppUrl(pathname) {
  return buildUrl(appBaseUrl, pathname);
}

export function buildCheckoutIntentUrl(plan = '') {
  const safePlan = normalizeCheckoutPlanId(plan) || PLAN_IDS.STARTER;
  const basePath = '/app/billing/checkout';
  const url = buildUrl(appBaseUrl, basePath);
  const out = new URL(url, typeof window !== 'undefined' ? window.location.origin : appBaseUrl);
  out.searchParams.set('plan', safePlan);
  return out.toString();
}
